/**
 * Created by eliasmj on 24/07/2015.
 *
 * Change Css attributes for templates tooltips, it will apply the properties you passed to the directive
 * #changeCssAttribute is object that contains the properties to be applied
 */
angular.module('qkr').directive('changeCssAttribute', () => ({

        restrict: 'A',
        scope: {
            changeCssAttribute: '='
        },

        link(scope) {
                angular.forEach(scope.changeCssAttribute, (styleObj) => {
                    const beWatched = function() {
                        // Console.log( $(styleObj.className).attr('class'))
                        return $(styleObj.className).attr('class');
                    };

                    scope.$watch(beWatched, (newValue) => {
                        if (newValue) {
                            angular.forEach(styleObj.properties, (property) => {
                                $(styleObj.className).css(property.name, property.value);
                            });
                        }
                    });
                });
        }
    }));




// WEBPACK FOOTER //
// ./src/directives/styles/changeCssAttribute.js